import { API_PRICING } from 'utils/constants'
import Api from './axiosInstance'

type FetchPricingParams = {
  limit: number
  page: number
  search?: string
  filters?: any
}

export const importEcomPricingData = async (data: any) => {
  return Api.post({
    url: API_PRICING.ECOM_PRICING_IMPORT,
    data: data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export const getEcomPricingDetails = (id?: string) => {
  return Api.get({
    url: `${API_PRICING.ECOM_PRICING}/${id}`,
  })
}

export const fetchEcomPricings = ({
  limit,
  page,
  search,
  filters,
}: FetchPricingParams) => {
  let options: any = {}

  if (search) {
    options.search = search
  }

  if (filters) {
    options = { ...options, ...filters }
  }

  const params = new URLSearchParams({
    limit,
    page,
    ...options,
  })

  return Api.get({
    url: `${API_PRICING.ECOM_PRICING}?${params}`,
  })
}

export const exportEcomPricingData = ({
  filters,
}: {
  filters: Record<string, any>
}) => {
  const params = new URLSearchParams(filters)
  return Api.get({
    url: `${API_PRICING.ECOM_PRICING_EXPORT}?${params}`,
  })
}
